import { useSupabase } from "@/app/supabase-provider";
import useSWR from "swr";

export function useResource<T>(
  resource: string,
  select: string = "*",
  filters: { column: string; op: string; value: string }[] = [],
  limit: number = 0,
  order: [string?, object?] = [],
) {
  const { supabase } = useSupabase();
  return useSWR([resource, select, filters], async () => {
    const query = supabase.from(resource).select(select);
    filters.forEach(({ column, op, value }) => {
      query.filter(column, op, value);
    });
    if (limit) {
      query.limit(limit);
    }
    if(order.length === 2) {
      query.order(order[0]!, order[1]!);
    }
    const { data, error } = await query;
    if (error) {
      throw error;
    } else {
      return data as T;
    }
  });
};
